import { render, staticRenderFns } from "./HTMLCodeEditor.vue?vue&type=template&id=1497a995&"
import script from "./HTMLCodeEditor.vue?vue&type=script&lang=js&"
export * from "./HTMLCodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports